import type { ReactElement } from "react";
import { DropdownButton, Text } from "@jsq/ds/core";
import { COLOR_NEUTRAL_500, COLOR_PRIMARY_600 } from "~/styles/variables";
import { PaddingIcon } from "./styles_vanilla.css";

export type EntityActionRendererParamsProps = {
  data: {
    actions: {
      isEntity: boolean;
      entityId: number;
      hasSomeSettings: boolean;
      allowEntityLevelSyncing: boolean;
      disabled: boolean;
      onUpdateJSQTxn: () => void;
      onActiveGLIntegration: () => void;
      onGoToWorkspace: () => void;
    };
  };
};

type Props = {
  params: EntityActionRendererParamsProps;
};

const Actions = ({ params }: Props): ReactElement => {
  const {
    entityId,
    hasSomeSettings,
    allowEntityLevelSyncing,
    disabled,
    onUpdateJSQTxn,
    onActiveGLIntegration,
    onGoToWorkspace,
  } = params.data.actions;

  const handleConfigureClick = () => {
    if (!disabled) {
      onActiveGLIntegration();
    }
  };

  const handleSyncSelect = () => {
    if (!disabled) {
      onUpdateJSQTxn();
    }
  };

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {/* Shortcut to allow users to setup settings for entity if no settings present on all categories */}
      {!hasSomeSettings && (
        <Text
          onClick={handleConfigureClick}
          style={{
            cursor: disabled ? "not-allowed" : "pointer",
            color: disabled ? COLOR_NEUTRAL_500 : COLOR_PRIMARY_600,
            paddingRight: "15px",
          }}
        >
          Configure
        </Text>
      )}
      <DropdownButton
        variant="muted"
        align="right"
        disabled={false}
        icon="ellipsis-h"
        buttonClassName={PaddingIcon}
        keepOpen
        usePortal
        data-testid="action-dropdown-button"
      >
        {!disabled && allowEntityLevelSyncing && (
          <DropdownButton.Action eventKey={entityId} onSelect={handleSyncSelect}>
            <Text>Sync JSQ transactions</Text>
          </DropdownButton.Action>
        )}
        {!disabled && hasSomeSettings && (
          <DropdownButton.Action eventKey={entityId} onSelect={handleConfigureClick}>
            <Text>Configure integration settings</Text>
          </DropdownButton.Action>
        )}

        <DropdownButton.Action eventKey={entityId} onSelect={() => onGoToWorkspace()}>
          <Text>View in client workspace</Text>
        </DropdownButton.Action>
      </DropdownButton>
    </div>
  );
};

export default Actions;
